import CommonIcon from "@/components/common-icon";
import { showTitle } from "@/utils/util";
export default {
  components: {
    CommonIcon
  },
  methods: {
    showTitle(item) {
      return showTitle(item, this);
    },
    showChildren(item) {
      return (
        item.children &&
        (item.children.length > 1 || (item.meta && item.meta.showAlways))
      );
    },
    getNameOrHref(item, children0) {
      if (item.href) {
        return `isTurnByHref_${item.href}`;
      } else {
        return children0 ? item.children[0].name : item.name;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/main/components/side-menu/mixin.js